<template>
  <div>
    <v-form ref="form">
      <v-row class="ma-0">
        <v-col cols="4">
          <label class="text-caption ml-1">{{ $t('Quantidade') }}</label>
          <v-text-field
            :rules="[
              (v) => (!!v && v > 0) || 'Digite a quantidade',
              (v) => v <= 35 || 'Máximo de 35 cadastros',
            ]"
            v-model="qtd"
            type="number"
            outlined
            style="max-width: 250px"
            class="primary-input"
            hide-details="auto"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="4">
          <label class="text-caption ml-1">{{ $t('Categoria') }}</label>
          <v-select
            append-icon="mdi-chevron-down"
            :rules="[(v) => v != null || 'Selecione a cateogoria']"
            single-line
            menu-props="auto"
            v-model="category"
            :item-text="(item) => $t(item.text)"
            item-value="value"
            :items="categories"
            outlined
            style="max-width: 250px"
            class="primary-input"
            hide-details="auto"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row class="ma-0" v-if="category != null">
        <v-col cols="12" class="py-0">
          <strong>Selecione os campos comuns</strong>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            v-if="category == 1 && selectedFields.includes('Unidade')"
            :label="$t('Setor')"
            value="Setor"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Localização')"
            value="Localização"
            v-if="category == 1"
          ></v-checkbox>
          <v-checkbox
            v-if="category == 0"
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Identificação')"
            value="Identificação"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            v-if="category == 1"
            :label="$t('Unidade')"
            value="Unidade"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Nome O.S.')"
            value="Nome O.S."
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Tipo O.S.')"
            value="Tipo O.S."
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Responsável')"
            value="Responsável"
          ></v-checkbox>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Solicitante')"
            value="Solicitante"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Data e hora de solicitação')"
            value="Data e hora de solicitação"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Solicitação / Reclamação')"
            value="Solicitação / Reclamação"
          ></v-checkbox>
          <v-checkbox
            v-if="institution.departmentTypes.includes(1)"
            v-model="selectedFields"
            hide-details="auto"
            :label="$t('Oficina')"
            value="Oficina"
          ></v-checkbox>
        </v-col>
      </v-row>

      <div class="d-flex justify-end">
        <v-btn color="primary mr-0" elevation="0" @click="confirm">
          {{ $t('Continue') }}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'SelectFieldsStep',

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
  },

  data() {
    return {
      institution: {},
      selectedFields: [],
      qtd: 0,
      category: null,
      categories: [
        { text: 'Equipamento', value: 0 },
        { text: 'Setor', value: 1 },
      ],
    }
  },

  methods: {
    confirm() {
      if (this.$refs.form.validate()) {
        const orders = []

        for (let index = 0; index < this.qtd; index++) {
          orders.push({
            category: this.category,
          })
        }

        const model = {
          orders,
          selectedFields: this.selectedFields,
          category: this.category,
        }

        this.$emit('confirm', model)
      }
    },
  },

  watch: {
    category() {
      this.selectedFields = []
    },
  },
}
</script>

<style></style>
